import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const ServiceParticulier = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);
  const benefits = [
    "Un jardin comme vous le souhaitez !",
    "Gestion des déchets verts",
    "Entretien régulier de l'espace vert à chaque demande",
    "Optimisation de la croissance des plantes (engrais, arrosage ...)",
    "Réduction du stress et de l'effort personnel",
    "Gain de temps"
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Service Particulier</div>
          <h1 className="page-title">Service Particulier</h1>
        </div>

        {/* Main Image Section - Two Images Side by Side */}
        <section className="modern-section" style={{padding: '0 0 clamp(2rem, 4vw, 3rem) 0'}}>
          <div style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 clamp(1rem, 3vw, 1.8rem)'
          }}>
            {/* Left Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/AmenagementPaysager/IMG_6269.webp" 
                alt="Aménagement paysager" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
            
            {/* Right Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/AmenagementPaysager/IMG_6270.webp" 
                alt="Jardin aménagé" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
          </div>
        </section>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div className="modern-card" style={{maxWidth: '900px', margin: '0 auto'}}>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                La société Callgarden est spécialisée dans l'entretien de jardin sur mesure, incluant la tonte, l'élagage, l'arrosage et bien plus. Nous sommes également à votre disposition pour répondre à toutes vos questions et vous fournir des conseils personnalisés afin de maintenir votre jardin en parfait état.
              </p>

              <h3 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginTop: '3rem', marginBottom: '2rem'}}>
                Nos services offrent de nombreux bénéfices :
              </h3>

              <ul style={{listStyle: 'none', padding: 0, marginTop: '2rem'}}>
                {benefits.map((benefit, index) => (
                  <li key={index} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1rem',
                    marginBottom: '1.5rem',
                    padding: '1rem',
                    background: 'var(--color-beige-light)',
                    borderRadius: '12px',
                    transition: 'var(--transition)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'var(--color-accent-light)';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'var(--color-beige-light)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                    <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" style={{
                      color: 'var(--color-primary)',
                      flexShrink: 0,
                      marginTop: '2px'
                    }}>
                      <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                    </svg>
                    <span style={{
                      color: 'var(--color-dark)',
                      fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)',
                      lineHeight: '1.6',
                      flex: 1
                    }}>{benefit}</span>
                  </li>
                ))}
              </ul>

              <div style={{marginTop: '3rem', textAlign: 'center'}}>
                <Link to="/contact" className="modern-button">
                  <span>Demander un devis</span>
                  <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceParticulier;

